import * as React from "react";
import { useContext } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Typography from "@mui/material/Typography";
import { Grid, useTheme } from "@mui/material";
import { GlobalContext } from "../Utils/Contexts";
import TicketValidator from "../Utils/TicketValidator";
import { getTicketNumber, IsDemoMode } from "../sharedCode/HelperMethods";
import { useLiveQuery } from "dexie-react-hooks";
import { TicketDatabase } from "../Utils/TicketDatabase";
import { getTicketById } from "../Utils/UtilityMethods";

interface Props {
    setDeleteConfirmation(shouldDelete: boolean): void;
}

export default function DeleteTicketConfirmationDialog(props: Props): JSX.Element {
    const context = useContext(GlobalContext);
    const theme = useTheme();
    const ticketList = useLiveQuery(async () => TicketDatabase.ticket.toArray());

    if (!ticketList) return <></>;

    const selectedTicket = getTicketById(ticketList, context.selectedTicketId);

    function handleClose(): void {
        props.setDeleteConfirmation(false);
    }

    function handleDeleteConfirmed(): void {
        props.setDeleteConfirmation(true);
    }

    return (
        <Dialog open={true}>
            <Grid container sx={{ p: 2 }}>
                <Grid container item xs={12} justifyContent={"center"}>
                    <Typography component="h1" variant="h6">
                        {IsDemoMode() && TicketValidator.IsReadOnly(selectedTicket) ? "* YOU CAN ONLY DELETE SIGNED TICKETS IN DEMO MODE *" : "DELETING TICKET"}
                    </Typography>
                </Grid>
                <Grid container item xs={12} sx={{ pt: 2 }}>
                    <Grid item flex={1}>
                        <Typography textAlign={"center"} sx={{ p: 1 }}>
                            {`ARE YOU SURE YOU WANT TO DELETE TICKET ${getTicketNumber(selectedTicket)}?`}
                        </Typography>
                        <Typography textAlign={"center"} color={theme.palette.error.main} sx={{ p: 1, pb: 4 }}>
                            THIS ACTION CANNOT BE UNDONE!
                        </Typography>
                    </Grid>
                </Grid>
                <Grid container item xs={12} justifyContent={"center"}>
                    <Button variant="contained" sx={{ m: 1 }} onClick={handleClose}>
                        CANCEL
                    </Button>
                    <Button variant="contained" color={"error"} sx={{ m: 1 }} onClick={handleDeleteConfirmed}>
                        DELETE
                    </Button>
                </Grid>
            </Grid>
        </Dialog>
    );
}
